<template>
  <div>
    <div
      class="bg-white p-3 rounded my-2"
      v-for="(usuario, index) in lista"
      :key="index"
    >
      <div class="row">
        <div class="col-md-3">
          <div class="label">Usuário</div>
          <div class="value">{{ usuario.nome }}</div>
        </div>
        <div class="col-md-5">
          <div class="label">CPF</div>
          <div class="value">{{ usuario.cpf | formataCPF }}</div>
        </div>
        <div class="col-md-3">
          <div class="label">Data de Cadastro</div>
          <div class="value">{{ usuario.dataSolicitacao | formataData }}</div>
        </div>
        <div class="col-md-1">
          <button
            class="btn btn-link"
            data-toggle="modal"
            data-target="#modalRemover"
            alt="Remover"
            title="Remover"
            @click="
              usuarioCpf = usuario.cpf;
              desc = usuario.nome;
            "
          >
            <i class="material-icons">delete</i>
          </button>
        </div>
      </div>
    </div>
    <ModalRemover
      :descricao="desc"
      tipo="Usuário"
      @click="remover"
      :loading="loading"
    />
  </div>
</template>
<script>
import ModalRemover from "@/components/cadastro/ModalRemover";
export default {
  name: "Lista",
  components: { ModalRemover },
  props: {
    lista: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      usuarioCpf: null,
      desc: null,
      loading: false,
    };
  },
  filters: {
    formataCPF(cpf) {
      //retira os caracteres indesejados...
      cpf = cpf.replace(/[^\d]/g, "");

      //realizar a formatação...
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    formataData(dataObj) {
      const data = new Date(dataObj);
      const dataStr =
        ("0" + data.getDate()).slice(-2) +
        "/" +
        ("0" + (data.getMonth() + 1)).slice(-2) +
        "/" +
        data.getFullYear();
      return dataStr;
    },
  },
  methods: {
    remover(props) {
      this.loading = true;
      if (props.props.resultado) {
        this.$http
          .post("/api/Clube/CancelarFuncionariosClubeVantagens", [
            this.usuarioCpf,
          ])
          .then((response) => {
            this.loading = false;
            this.$toast.open({
              message: response.data.mensagem,
              type: "success",
              duration: 6000,
            });
            document.querySelector("#closeModalClick").click();
            this.$emit("click", {
              props: {
                carregarLista: true,
              },
            });
          })
          .catch((error) => {
            if (error.response.status === 401) {
              this.$router.push({ name: "login" });
            }
            console.error(error);
            this.$toast.open({
              message: "Erro ao cancelar usuários, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 5px;
  line-height: 1.4;
}
.value {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.simple-value {
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
</style>
